import { useEffect, useRef } from 'react'
import { Info } from 'react-feather'
import Tooltip from '@components/common/tooltip'

type Props = {
  label: string
  type: string
  id: string
  name: string
  value: string
  required?: boolean
  autoFocus?: boolean
  disabled?: boolean
  onChange: (e: React.FormEvent<HTMLInputElement>) => void
  onKeyUp?: (e: React.FormEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void
  toolTipText?: string
  list?: string
}

const FloatingLabelInput = ({
  id,
  name,
  value,
  type,
  required,
  autoFocus = false,
  onKeyUp,
  disabled,
  onBlur,
  onChange,
  label,
  toolTipText,
  list,
}: Props) => {
  const floatingInputRef = useRef<HTMLInputElement>(null)

  const handleFocusOut = (e) => {
    onBlur?.(e)
  }

  useEffect(() => {
    if (autoFocus) {
      floatingInputRef.current.focus()
    }
  }, [])

  return (
    <div className="relative w-full bg-gray-600 rounded floating-input text-grey">
      <input
        ref={autoFocus ? floatingInputRef : null}
        className="form-input"
        id={id}
        // Label styles are determined whether placeholder is visible or not
        // Since floating fields do not require a placeholder, keeping a white space
        placeholder=" "
        name={name}
        value={value}
        type={type}
        required={required}
        onBlur={(e) => handleFocusOut(e)}
        onKeyUp={onKeyUp}
        onChange={onChange}
        disabled={disabled}
        autoFocus={autoFocus}
        list={list}
      />
      <label htmlFor={name}>{label}</label>
      {toolTipText && (
        <>
          <div className="flex absolute top-0 right-0 cursor-pointer">
            <span className="self-stretch bg-grey-600 my-3 box-border w-px"></span>
            <Tooltip
              content={
                <p className="p-2 text-grey-900 font-400 w-96">{toolTipText}</p>
              }
              showOnHover
              placement="bottom-center"
            >
              <Info
                size={18}
                className="cursor-pointer text-grey-600 my-4 mr-3 ml-2"
              />
            </Tooltip>
          </div>{' '}
        </>
      )}
    </div>
  )
}

export default FloatingLabelInput
